import * as React from 'react';

import {Button} from 'shells/button/button';
import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
import {EmptyStateSmall} from 'shells/empty-states/empty-state-small';
import {Illustration} from 'shells/illustrations/illustration';

import {useDismissibleUserSetting} from '../../../../util/hooks/use-dismissible-user-setting';

export function NoFiltersEmptyState() {
    const {shouldShow, onDismiss} = useDismissibleUserSetting('has_viewed_prospector_onboarding');
    const handleGetStarted = () => {
        if (onDismiss) {
            onDismiss();
        }
    };

    return shouldShow ? (
        <EmptyStateLarge
            title='Find your future prospects!'
            detailTextBullets={[
                'ProspectorIQ lets you search for people you don’t know about yet, without needing the company to be in your CRM or on your website.',
                'Use your credits to unlock contact information that your sales team can use to reach out to your prospects.',
                'Turn your prospects into leads, similar to PeopleIQ with our “Add and create lead” flow.',
            ]}
            icon={<Illustration src='man-magnifying-crowd' width={250} />}
            cta={
                <Button size='xlarge' variant='primary' onClick={handleGetStarted}>
                    Start searching
                </Button>
            }
        />
    ) : (
        <div className='pt-64'>
            <EmptyStateSmall
                title='Add your search criteria to see results'
                subtitle='Select criteria to the left and any matched prospects will appear here.'
                icon={
                    <div style={{width: 160}}>
                        <Illustration src='hand-pointing-left' width='100%' height='100%' />
                    </div>
                }
            />
        </div>
    );
}
